import { useEffect } from "react";

const ScrollToTopBelowNavbar = () => {
  useEffect(() => {
    const navbar = document.querySelector("nav"); 
    if (!navbar) return;

    const navbarBottom = navbar.getBoundingClientRect().bottom + window.scrollY;

    window.scrollTo({
      top: navbarBottom,
      left: 0,
      behavior: "smooth", // smooth scroll
    });
  }, []);

  return null;
};

export default ScrollToTopBelowNavbar;
